import React, { useState, useEffect, useRef } from 'react';
import styles from './HomeVideo.module.css';

const HomeVideo = ({ imageUrl, imageUrlMobile, colorMode = "colorWhite" }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle video loading
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleLoadedData = () => {
        setIsLoading(false);
      };

      const handleError = () => {
        setIsLoading(false);
        console.error('Video failed to load');
      };

      video.addEventListener('loadeddata', handleLoadedData);
      video.addEventListener('error', handleError);

      return () => {
        video.removeEventListener('loadeddata', handleLoadedData);
        video.removeEventListener('error', handleError);
      };
    }
  }, [isMobile]);

  const videoSource = isMobile ? imageUrlMobile : imageUrl;

  return (
    <div className={styles.homeVideoContainer}>
      {isLoading && (
        <div className={styles.videoLoading}>
          
        </div>
      )}
      
      <video
        ref={videoRef}
        className={styles.homeVideo}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        style={{ opacity: isLoading ? 0 : 1 }}
      >
        <source src={videoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default HomeVideo;